const NavigationItems = [
  {
    link: "/",
    text: "Home",
  },
  {
    link: "/contact",
    text: "Contact",
  },
  {
    link: "/nomad",
    text: "Nomad",
  },
];

export default NavigationItems;



// WEBPACK FOOTER //
// ./src/app/partials/navigation/config.ts